<template>
  <div class="postback-breakdown-details">
    <table class="table table-sm table-bordered mb-0">
      <thead class="table-secondary">
        <tr>
          <th>Call ID</th>
          <th>Caller Phone</th>
          <th>Date/Time</th>
          <th>Postback Received</th>
          <th>Category</th>
          <th class="text-right">
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="call in calls"
          :key="call.callId"
        >
          <td>
            <div class="d-flex align-items-center">
              <code class="text-truncate call-id-cell mr-1">{{ call.callId }}</code>
              <a
                href
                @click.prevent="copyTextToClipboard(call.callId, 'Call ID copied')"
              >
                <CIcon
                  name="cil-copy"
                  size="sm"
                />
              </a>
            </div>
          </td>
          <td>{{ call.callerId }}</td>
          <td>{{ formatDateTime(call.callDate) }}</td>
          <td>{{ formatDateTime(call.creationDate) }}</td>
          <td>{{ call.category }}</td>
          <td class="text-right">
            {{ formatAmount(call.amount) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import copyToClipboardMixin from '@/mixins/copy-to-clipboard-mixin'
import { formatAmount } from '@/utils'

export default {
  name: 'PostbackCallsBreakdown',

  mixins: [copyToClipboardMixin],

  props: {
    calls: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    formatDateTime(date) {
      if (!date) {
        return 'N/A'
      }

      return new Date(date).toLocaleString()
    },

    formatAmount
  }
}
</script>

<style scoped>
.postback-breakdown-details {
  background-color: #ffffff;
  padding: 0.75rem;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}

.postback-breakdown-details code {
  background-color: #e9ecef;
  padding: 0.2rem 0.4rem;
  border-radius: 0.2rem;
  font-size: 0.875rem;
}

.call-id-cell {
  max-width: 120px;
  display: inline-block;
}
</style>
